import { type ViewItemListEvent, viewItemListEventSchema } from './eCommerceTrackingEventSchema';
import logger from '../logger';

export type ViewItemListEventProps = Omit<ViewItemListEvent, 'event_name' | 'event'>;

export const buildViewItemListEvent = (props: ViewItemListEventProps): ViewItemListEvent => {
  const {
    anonymousId,
    authenticatedId,
    ecommerce: { item_list_name, item_list_id, items }
  } = props;

  const viewItemListEvent: ViewItemListEvent = {
    event: 'ga4_event_ecommerce',
    event_name: 'view_item_list',
    anonymousId,
    authenticatedId,
    ecommerce: {
      item_list_name,
      item_list_id,
      items
    }
  };

  const result = viewItemListEventSchema.safeParse(viewItemListEvent);

  if (!result.success) {
    logger.error(result.error, 'Invalid view item list event');
  }

  return viewItemListEvent;
};
